import { createModuleBuilder } from '../../app';
import { PersistingErrorModule } from '../persisting-error';
import { usePersistingErrorStore } from '../persisting-error/store';

export function createPersistVueErrorsModule() {
    return createModuleBuilder()
        .demand<PersistingErrorModule>()
        .execute((app) => {
            app.on('vueError', (error) => {
                usePersistingErrorStore(app.getPinia()).showError(error);
            });
        })
        .end();
}

export type PersistVueErrorsModule = ReturnType<typeof createPersistVueErrorsModule>;
